module.exports = __webpack_public_path__ + "img/tasks-app.02b5e018.svg";